module.exports = __webpack_public_path__ + "img/4.84f5c47d.png";